import GatewayAxiosClient from '../GatewayAxiosClient';
import { getToken } from '../../session';
import type { AddressValidationRequest, AddressValidationResponse } from './types';

export class AddressService {
  public async validateAddress(payload: AddressValidationRequest): Promise<AddressValidationResponse> {
    const res = await GatewayAxiosClient.post('/address-proxy/api/v1/address/validate', payload, {
      headers: {
        authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data;
  }
}
